import { __assign } from "tslib";
export var contentScopeSettingsApiRelativePath = "/helpcenter/contentScope";
export var localesSettingsApiRelativePath = "/helpcenter/locales";
export var createContentVisibilityApi = function (baseUrl, http) {
    var scopeApiUrl = "" + baseUrl + contentScopeSettingsApiRelativePath;
    var localesApiUrl = "" + baseUrl + localesSettingsApiRelativePath;
    return {
        getLocaleContentSettings: function (dto) {
            return http.get(scopeApiUrl + "/" + dto.locale + (dto.brandId ? "?brandId=" + dto.brandId : ''));
        },
        updateLocaleContentSettings: function (dto) {
            return http.put(scopeApiUrl + "/" + dto.locale, dto.brandId ? __assign(__assign({}, dto.data), { brandId: dto.brandId }) : dto.data);
        },
        getEnabledLocales: function (brandId) { return http.get(localesApiUrl + "/enabled" + (brandId ? "?brandId=" + brandId : '')); },
        enableLocale: function (dto) {
            return http.put(localesApiUrl + "/" + dto.locale + "/enable" + (dto.brandId ? "?brandId=" + dto.brandId : ''), {});
        },
        disableLocale: function (dto) {
            return http.put(localesApiUrl + "/" + dto.locale + "/disable" + (dto.brandId ? "?brandId=" + dto.brandId : ''), {});
        }
    };
};
//# sourceMappingURL=index.js.map